import * as React from 'react';
import { Grid } from '@material-ui/core';
import TextField from '../../../../ui-components/TextField/TextField';
import NewItemButton from '../../../../ui-components/Button/NewItemButton';
import AddRoomDialog from '../AddRoomDialog';
import { room } from "../../../../model/room"

interface IProps {
    createRoom: (room: room) => void;
    classes: any;
    smallScreen: boolean;
    filter: string;
    updateFilter: (f: string) => void;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default (props: IProps) => {
    const [open, setOpen] = React.useState(false);
    return (
        <Grid container className={props.classes.SearchContainer}>
            <Grid item sm={8} xs={10} className={props.classes.SearchSection}>
                <TextField
                    label="Room"
                    value={props.filter}
                    onChange={props.updateFilter}
                    onBlur={null}
                />
            </Grid>
            {!props.smallScreen &&
                <Grid item sm={4} className={props.classes.searchButtons}>
                    {/* <div className={props.classes.searchButton}>
                        <Button onClick={() => null}>Cerca</Button>
                    </div> */}
                    <div className={props.classes.searchButton}>
                        <NewItemButton onClick={() => setOpen(true)} text='Nuova' />
                    </div>
                    <AddRoomDialog
                        open={open}
                        onConfirm={(room) => { props.createRoom(room); setOpen(false) }}
                        onCancel={() => { setOpen(false) }} />
                </Grid>
            }
        </Grid>
    );
}